import React from "react";
import { Map } from "immutable";
import _ from "lodash";
import PropTypes from "prop-types";
import { Detail, DetailTable } from "MODULES/shared/components/DetailTable";
import { CARRIERS } from "MODULES/shared/constants";

const shippingAddressLine = address => {
  const { line1, line2 } = address;

  if (line2) {
    return `${line1}, ${line2}`;
  }

  return line1;
};

export default function ShippingAddressTable({
  address,
  fob,
  shippingMethod,
  renderCarrier = true
}) {
  const method = shippingMethod || Map();
  const carrier = CARRIERS[method.get("carrier")] || {};

  return (
    address && (
      <div>
        <DetailTable>
          <Detail label="FOB" value={fob} />
          {address.get("company_name") && (
            <Detail label="Company Name" value={address.get("company_name")} />
          )}
          {address.get("care_of") && (
            <Detail label="C/O" value={address.get("care_of")} />
          )}
          <Detail
            label="Address Line"
            value={shippingAddressLine(address.toJS())}
          />
          <Detail label="City" value={address.get("city")} />
          <Detail
            label="State/ Province/ Region"
            value={address.get("state")}
          />
          <Detail label="Zip/ Postal Code" value={address.get("postal_code")} />
          <Detail label="Country" value={address.get("country")} />
        </DetailTable>
        {renderCarrier && [
          <hr key="carrier-header" className="hr-xs hr-dashed" />,
          <DetailTable key="carrier-table">
            <Detail label="Carrier" value={carrier.label} />
            <Detail
              label="Method"
              value={_.get(
                carrier.shippingMethods,
                `${method.get("shipping_method")}.label`
              )}
            />
            <Detail label="Account #" value={method.get("account_number")} />
          </DetailTable>
        ]}
      </div>
    )
  );
}

ShippingAddressTable.propTypes = {
  address: PropTypes.instanceOf(Map),
  shippingMethod: PropTypes.instanceOf(Map)
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/ShippingAddressTable/ShippingAddressTable.jsx